
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Join the St. Francis Xavier Exposition in Goa, a grand celebration of faith and culture featuring historical displays, cultural programs, and spiritual ceremonies honoring the life of St. Francis Xavier.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Experience the St. Francis Xavier Exposition, where you can explore the rich heritage of Goa through vibrant celebrations, religious rituals, and the display of sacred relics.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Immerse yourself in the St. Francis Xavier Exposition, a remarkable event showcasing devotion, culture, and community spirit in honor of the beloved saint.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'st francis xavier exposition in goa, st francis xavier exposition goa 2024, st francis xavier exposition date, st francis xavier exposition years, st francis xavier feast, st francis xavier church goa, st francis xavier death, st francis xavier goa story, st francis xavier body',
        },
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Historical Significance",
      text: "Discover the rich history of St. Francis Xavier and his impact on Christianity in Goa during the exposition.",
    },
    {
      title: "Cultural Celebrations",
      text: "Experience vibrant cultural programs, processions, and traditional music that bring the spirit of Goa to life!",
    },
    {
      title: "Spiritual Journey",
      text: "Participate in heartfelt masses and ceremonies that offer a deep spiritual connection to St. Francis Xavier.",
    },
    {
      title: "Community and Devotion",
      text: "Join thousands of devotees from around the world as they gather to pay respects and celebrate together during this grand event.",
    },
  ],

      title: 'St Francis Xavier Exposition - St Francis Xavier Exposition Goa',
    };
  },


jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
    
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/st-francis-xavier-exposition`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/st-francis-xavier-exposition`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: 'Join the St. Francis Xavier Exposition in Goa, a grand celebration of faith and culture featuring historical displays, cultural programs, and spiritual ceremonies honoring the life of St. Francis Xavier.',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/st-francis-xavier-exposition`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },

            {
        "@type": "Event",
        "@id": "https://www.goa.app/st-francis-xavier-exposition",
        "name": "St. Francis Xavier Exposition Goa",
        "description": "The grand celebration of St. Francis Xavier's Exposition, including cultural programs and historical displays.",
        "startDate": "2024-11-21T06:00:00+00:00",
        "endDate": "2025-01-05T19:03:52+00:00",
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
          "@type": "Place",
          "name": "Basilica of Bom Jesus",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Old Goa Rd, Bainguinim, Goa",
            "addressLocality": "Goa",
            "postalCode": "403402",
            "addressCountry": "IN"
          }
        },
        "organizer": {
          "@type": "Organization",
          "@id": "https://goa.app",
          "name": "Goa App",
          "url": "https://goa.app"
        },
        "image": {
          "@type": "ImageObject",
          "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D',
          "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D'
        }
      },

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/st-francis-xavier-exposition",
        "url": "https://www.goa.app/st-francis-xavier-exposition",
        "name": "St Francis Xavier Exposition Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T05%3A40%3A46.019ZUntitled-design-%283%29.png?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=QVhTyUM%2BMgfy34C4eQQsw%2BGhUeA2s780ixMyXtxalmTmBP95At0gXRilR5J%2B%2BiPj7JKWD0bx6%2B6zcuf3hM1%2FRalNg2wI0Tojt1MSCGeI38%2FmRWl5NL9v%2Fq6RSuDxpLEtS%2FruWyhVTaAkyx3No8nYZuak2rc%2F7u63%2Bgj4Z5v3GoauG0xXPK0twMqb2DydF9aIcca59VNB0Kj8ehCZhaIOIL4U9BoJeTiqsAReOsTd8AHPuSPMkoznuOzWx%2F5kZsPVzc1%2B9lGopwaT1ce3qbD5qcrJihaHTFI%2BEWKhMGVDvQcDeYqeXgP68ejpEWVANz9hPF9%2B5KvsRGR2aDFK09Qa1g%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Join the St. Francis Xavier Exposition in Goa, a grand celebration of faith and culture featuring historical displays, cultural programs, and spiritual ceremonies honoring the life of St. Francis Xavier.",
        "breadcrumb": {
            "@id": "https://www.goa.app/st-francis-xavier-exposition/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/st-francis-xavier-exposition"]
        }]
      },
      {
        '@type': 'FAQPage',
        'mainEntity': [
          {
            '@type': 'Question',
            'name': 'How do I attend the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'You can attend the St. Francis Xavier Exposition by visiting the Basilica of Bom Jesus in Old Goa during the exposition period. It’s advisable to check the official schedule and plan your visit in advance.'
            }
          },
          {
            '@type': 'Question',
            'name': 'What are the key events during the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'The key events during the St. Francis Xavier Exposition include special masses, processions, cultural programs, and the display of his relics for public veneration.'
            }
          },
          {
            '@type': 'Question',
            'name': 'What should I wear when attending the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'It’s recommended to wear modest and comfortable clothing, suitable for a religious event. Dress respectfully and consider the weather when planning your outfit.'
            }
          },
          {
            '@type': 'Question',
            'name': 'How long does the St. Francis Xavier Exposition last?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'The St. Francis Xavier Exposition typically lasts for a month, culminating in the feast day celebrations on 3rd December'
            }
          },
          {
            '@type': 'Question',
            'name': 'Can I participate in the ceremonies during the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Yes, all visitors are welcome to participate in the ceremonies, including masses and processions during the St. Francis Xavier Exposition.'
            }
          },
          {
            '@type': 'Question',
            'name': 'Are there any special accommodations for visitors during the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Many local accommodations offer special packages during the exposition period. It’s best to book your stay in advance due to high demand.'
            }
          },
          {
            '@type': 'Question',
            'name': 'What is the best time to visit the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'The best time to visit the St. Francis Xavier Exposition is during the main events, especially from late November to early December when the relics are displayed.'
            }
          },
          {
            '@type': 'Question',
            'name': 'Is there an entry fee for the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'No, there is no entry fee to visit the Basilica of Bom Jesus during the St. Francis Xavier Exposition, but donations are welcomed.'
            }
          },
          {
            '@type': 'Question',
            'name': 'Can I bring my family to the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Yes, the St. Francis Xavier Exposition is a family-friendly event, and all ages are welcome to attend and participate in the celebrations.'
            }
          },
          {
            '@type': 'Question',
            'name': 'Are there any food stalls or refreshments available during the St. Francis Xavier Exposition?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Yes, there are usually food stalls and refreshments available near the Basilica during the exposition, offering a variety of local delicacies.'
            }
          },
          {
            '@type': 'Question',
            'name': 'Is the St. Francis Xavier Exposition suitable for tourists?',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': 'Absolutely! The St. Francis Xavier Exposition is a major cultural and religious event, making it an enriching experience for tourists interested in Goan heritage and spirituality.'
            }
          }

        ]
      }
    ]
  };
},


};


  